import { useState } from "react";
import { useMutation } from "@apollo/client";
import { CREATE_SELF_SOC } from "./self-soc.query";
import { SelfSocResponse } from "./self-soc.interface";

export const useCreateSelfSoc = () => {
  const [createSelfSoc, { data, loading, error, reset }] =
    useMutation<{ createSelfSoc: SelfSocResponse }>(CREATE_SELF_SOC);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const addSelfSoc = async (addSelfSocData: {
    animalId: string;
    eventName: string;
    monthIndex: number;
    year: number;
    fulfilledDate: number;
  }) => {
    if (isSubmitting || loading) return;
    setIsSubmitting(true);
    try {
      await createSelfSoc({
        variables: { addSelfSocData },
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    addSelfSoc,
    selfSocData: data?.createSelfSoc,
    loading: loading || isSubmitting,
    error,
    reset,
  };
};
